import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Container, Typography, } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useMutation } from "@tanstack/react-query";
import { ToastContext } from "../../contexts/toast-context.jsx";
import { resendEmail } from "../../api/email-verification-api.js";

export function ResendEmailVerification() {
  const { t } = useTranslation(["auth", "validation", "common"]);
  const { showError, showSuccess } = useContext(ToastContext);
  const { state: { email } } = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    if (!email)
      navigate("/login");
  }, [email]);

  const [seconds, setSeconds] = useState(0);

  const mutation = useMutation({
    mutationFn: () => {
      setSeconds(60);
      return resendEmail(email)
    },
    onSuccess: () => {
      showSuccess(t("resendEmailSuccess"));
    },
    onError: () => {
      showError(t("resendEmailError"));
    }
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds(prevSeconds => prevSeconds - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [seconds]);

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          px: 5,
          py: 3,
          width: "400px",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          margin: "auto",
          gap: 4
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "26px",
            textTransform: "uppercase",
            mt: "15px",
          }}
        >
          {t("login")}
        </Typography>
        {t("emailNotVerified")}
        <Button variant="contained" onClick={mutation.mutate} disabled={mutation.isPending || seconds > 0}>
          {t("resendEmail")}
        </Button>
        {seconds > 0 && <span>{t("resendWait", { seconds })}</span>}
      </Card>
    </Container>
  );
}
